export const blockIconsBusinessandpaymentsPaymentsNew = (
	<span className='material-symbols-outlined'>payments</span>
);
